import React, { SVGProps } from "react";

type DoubleLineMenuProps = SVGProps<SVGSVGElement>;

export const DoubleLineMenu = (props: DoubleLineMenuProps) => (
  <svg
    {...props}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 9.10004L2 9.10004L2 10.1L14 10.1V9.10004Z"
      fill="currentColor"
    />
    <path
      d="M14 5.60004L2 5.60004L2 6.60003L14 6.60003V5.60004Z"
      fill="currentColor"
    />
  </svg>
);
